import { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { getTranslation, getBaseModel } from '../utils/bike-schema'
import { getChoice } from '../utils/bike-config'
import RenderTable from './RenderTable'
import { optionSelected } from '../actions'

const ChoiceConfirmation = () => {
  const dispatch = useDispatch()
  const bikeConfig = useSelector((state) => state.bikeConfig)

  const baseModel = getBaseModel(bikeConfig.baseModelId)
  const components = baseModel.components
    .filter((component) => component.confirm)
    .map((component) => {
      const choice = getChoice(bikeConfig, component)
      return {
        component,
        currentOption: choice && choice.option
      }
    })

  const [visible, setVisible] = useState(false)

  return (
    <div className="velorbis-customizer-space-dist-v">
      {components.map(({ component, currentOption }) => (
        <div key={component.id} className="velorbis-customizer-form-control">
          <div>
            {getTranslation(component.name)}
            {component.id === 'frame-size' && (
              <div className="tooltip" onMouseEnter={() => setVisible(true)}>
                &#9432;
              </div>
            )}
          </div>
          {visible && (
            <div className="tooltip-content">
              <div className="gearstable-wrapper">
                <button
                  className="close-button"
                  onClick={() => setVisible(false)}
                >
                  X
                </button>
                <RenderTable />
              </div>
            </div>
          )}
          <select
            className="velorbis-customizer-input"
            value={currentOption && currentOption.id}
            onChange={(e) =>
              dispatch(optionSelected(component.id, e.target.value))
            }
          >
            {component.options.map((option) => (
              <option key={option.id} value={option.id}>
                {getTranslation(option.name)}
              </option>
            ))}
          </select>
        </div>
      ))}
    </div>
  )
}

export default ChoiceConfirmation
